'use strict';

// NOTE: These types should be in-sync with the semantic-grid themes in Supernova
var SCREEN_SIZES = /*#__PURE__*/ function(SCREEN_SIZES) {
    SCREEN_SIZES["mobile375"] = "mobile375";
    SCREEN_SIZES["tablet834"] = "tablet834";
    SCREEN_SIZES["desktop1024"] = "desktop1024";
    SCREEN_SIZES["desktop1280"] = "desktop1280";
    return SCREEN_SIZES;
}({});
const MIN_BREAKPOINTS = {
    ["tablet834"]: 834,
    ["desktop1024"]: 1024,
    ["desktop1280"]: 1280
};

exports.MIN_BREAKPOINTS = MIN_BREAKPOINTS;
exports.SCREEN_SIZES = SCREEN_SIZES;
//# sourceMappingURL=breakpoints.cjs.map
